<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPartPrices"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part" id="filter-" size="sm" :model.sync="filter.partId" @input="getParts" @focus="getParts" />
					<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" label="Start Date" size="sm" :modelFrom.sync="filter.startDateFrom" :modelTo.sync="filter.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datetimepicker-range id="fieldset-end-date" label-cols-sm="4" label-cols-lg="3" label="End Date" size="sm" :modelFrom.sync="filter.endDateFrom" :modelTo.sync="filter.endDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-textbox id="fieldset-part-name" label-cols-sm="4" label-cols-lg="3" label="Part Name" label-for="filter-part-name" size="sm" :model.sync="filter.partName" />
					<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Classification" id="filter-" size="sm" :model.sync="filter.partClassification" @input="getPartClassifications" @focus="getPartClassifications" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.customerId" @input="getCustomers" @focus="getCustomers" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Vendor" id="filter-" size="sm" :model.sync="filter.vendorIdId" @input="getVendors" @focus="getVendors" />
					<app-input-textbox id="fieldset-price-process-from" label-cols-sm="4" label-cols-lg="3" label="Price Process From" label-for="filter-price-process-from" size="sm" :model.sync="filter.priceProcessFrom" />
					<app-input-textbox id="fieldset-price-process-to" label-cols-sm="4" label-cols-lg="3" label="Price Process To" label-for="filter-price-process-to" size="sm" :model.sync="filter.priceProcessTo" />
					<app-input-textbox id="fieldset-price-product-from" label-cols-sm="4" label-cols-lg="3" label="Price Product From" label-for="filter-price-product-from" size="sm" :model.sync="filter.priceProductFrom" />
					<app-input-textbox id="fieldset-price-product-to" label-cols-sm="4" label-cols-lg="3" label="Price Product To" label-for="filter-price-product-to" size="sm" :model.sync="filter.priceProductTo" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getPartPrices"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Part Price</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/partprice/PartPrice.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<!-- <b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item> -->
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/partprice/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/partprice/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-partprice" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="partPrices" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="partPrices.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Part" class="table-filter">
							<v-select append-to-body label="partNumber" :options="parts" :value="filter.partId" :reduce="item => item.id" v-model="filter.partId" :filterable="true" @input="getPartPricesWithoutLoading" @search="getParts"></v-select>
						</b-th>
						<b-th stacked-heading="Part Name" class="table-filter">
							<b-form-input id="input-part-name-table" @input="getPartPricesWithoutLoading" v-model="filter.partName" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Part Classification" class="table-filter">
							<v-select append-to-body label="code" :options="partClassifications" :value="filter.partClassification" :reduce="item => item.id" v-model="filter.partClassification" :filterable="true" @input="getPartPricesWithoutLoading" @search="getPartClassifications"></v-select>
						</b-th>
						<b-th stacked-heading="Start Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Date" size="sm" :modelFrom.sync="filter.startDateFrom" :modelTo.sync="filter.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getPartPricesWithoutLoading" />
						</b-th>
						<b-th stacked-heading="End Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-end-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="End Date" size="sm" :modelFrom.sync="filter.endDateFrom" :modelTo.sync="filter.endDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getPartPricesWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Vendor" class="table-filter">
							<v-select append-to-body label="code" :options="vendors" :value="filter.vendorIdId" :reduce="item => item.id" v-model="filter.vendorIdId" :filterable="true" @input="getPartPricesWithoutLoading" @search="getVendors"></v-select>
						</b-th>
						<b-th stacked-heading="Customer" class="table-filter">
							<v-select append-to-body label="code" :options="customers" :value="filter.customerId" :reduce="item => item.id" v-model="filter.customerId" :filterable="true" @input="getPartPricesWithoutLoading" @search="getCustomers"></v-select>
						</b-th>
						<b-th stacked-heading="Price Process" class="table-filter">
							<b-form-input id="input-price-process-from" @input="getPartPricesWithoutLoading" v-model="filter.priceProcessFrom" size="sm"></b-form-input>
							<b-form-input id="input-price-process-to" @input="getPartPricesWithoutLoading" v-model="filter.priceProcessTo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Price Product" class="table-filter">
							<b-form-input id="input-price-product-from" @input="getPartPricesWithoutLoading" v-model="filter.priceProductFrom" size="sm"></b-form-input>
							<b-form-input id="input-price-product-to" @input="getPartPricesWithoutLoading" v-model="filter.priceProductTo" size="sm"></b-form-input>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(part)="row">
						<a @click="() => ( $router.push({ name: 'partpricedetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.part != null && row.item.part.partNumber != null && row.item.part.partNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.part.partNumber.slice(0, 30) + (row.item.part.partNumber.length > 30 ? "..." : "" ) : row.item.part.partNumber : "" }}
						</a>
					</template>

			<template v-slot:cell(partName)="row">
				{{ row.item.part != null ? row.item.part.partName : "" }}
			</template>
			<template v-slot:cell(partClassification)="row">
				{{ row.item.part != null ? row.item.part.partClassification != null ? row.item.part.partClassification.code : "" : "" }}
			</template>
			<template v-slot:cell(startDate)="row">
				{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(endDate)="row">
				{{ row.item.endDate | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(vendorId)="row">
				{{ row.item.vendorId != null ? row.item.vendorId.code : "" }}
			</template>
			<template v-slot:cell(customer)="row">
				{{ row.item.part != null ? row.item.part.customer != null ? row.item.part.customer.code : "" : "" }}
			</template>
			<template v-slot:cell(priceProcess)="row">
				{{ Number(row.item.priceProcess).toLocaleString() }}
			</template>
			<template v-slot:cell(priceProduct)="row">
				{{ Number(row.item.priceProduct).toLocaleString() }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(model.part != null) ? (model.part.partClassification != null) ? model.part.partClassification.code : null : null"  />
						<app-input-datepicker id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :model.sync="row.item.startDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datepicker id="fieldset-end-date" label-cols-lg="12"  label="End Date" size="sm" :model.sync="row.item.endDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.vendorIdId" label="Vendor" :selected="row.item.vendorId != null ? row.item.vendorId.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-price-process" label-cols-lg="12" label="Price Process" label-for="input-price-process" size="sm" :thousandSeparator="true" :model.sync="row.item.priceProcess"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-price-product" label-cols-lg="12" label="Price Product" label-for="input-price-product" size="sm" :thousandSeparator="true" :model.sync="row.item.priceProduct"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(partPricesPaging != null ? partPricesPaging.dataCount : 0)"
									:per-page="(partPricesPaging != null ? partPricesPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-partprice.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-partprice.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import PartPrice from '@/models/PartPrice/PartPrice';
import PartPriceList from '@/models/PartPrice/PartPriceList';
import PartPriceFilter from '@/filters/PartPrice/PartPriceFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import AppInputTextbox from '@/components/AppInputTextbox';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import PartClassification from '@/models/PartClassification/PartClassification';
import { part } from 'file-loader';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';

export default {
	components : {
		PartPrice, 
		PartPriceList, 
		PartPriceFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppInputTextbox,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"part": {}, "class" : "th-part first-child", "label" : "Part", key: 'part', sortable: true}, 
				{"partName": {}, "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: true}, 
				{"partClassification": {}, "class" : "th-part-classification last-child", "label" : "Part Classification", key: 'partClassification', sortable: true}, 
				{"startDate": {}, "class" : "th-start-date d-stack-none", "label" : "Start Date", key: 'startDate', sortable: true}, 
				{"endDate": {}, "class" : "th-end-date d-stack-none", "label" : "End Date", key: 'endDate', sortable: true}, 
				{"vendorId": {}, "class" : "th-vendor-id d-stack-none", "label" : "Vendor", key: 'vendorId', sortable: true}, 
				{"customer": {}, "class" : "th-customer d-stack-none", "label": "Customer", key: 'customer', sortable: true},
				{"priceProcess": {}, "class" : "th-price-process d-stack-none", "label" : "Price Process", key: 'priceProcess', sortable: true}, 
				{"priceProduct": {}, "class" : "th-price-product d-stack-none", "label" : "Price Product", key: 'priceProduct', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			partPrices: [],
			partPricesPaging: {},
			parts : [],
			vendors : [],
			partClassifications : [],
			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			customers: [],
		}
	},	methods : {
		getPartPrices : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PartPrice.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.partPrices = result.data
					this.partPricesPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPartPricesWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PartPrice.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.partPrices = result.data
					this.partPricesPaging = result
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			if(input == '' && this.filter.partId != null)
			{
				filter.id = this.filter.partId
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.vendorIdId != null)
			{
				filter.id = this.filter.vendorIdId
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.customerId != null)
			{
				filter.id = this.filter.customerId
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		getPartClassifications : async function(input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.partClassificationId != null)
			{
				filter.id = this.filter.partClassificationId
			}
			await PartClassification.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partClassifications = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new PartPriceFilter();
			this.getPartPrices();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPartPrices();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PartPrice.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PartPrice.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			PartPrice.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			PartPrice.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPartPrices();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PartPrice.deleteMultipleData(this).then(result => {
					this.getPartPrices();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePartPriceParent = document.getElementById('table-list-partprice').parentNode;
			tablePartPriceParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePartPriceParent.scrollWidth - tablePartPriceParent.offsetWidth) == Math.ceil(tablePartPriceParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePartPriceParent = document.getElementById('table-list-partprice').parentNode;
			tablePartPriceParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePartPriceParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PartPriceFilter();
		this.getParts()
		this.getVendors()
		this.getPartClassifications()
		this.getCustomers()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Part Price"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPartPrices();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPartPrices();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPartPrices();
			}
		},
		currentPage: {
			handler: function() {
				this.getPartPrices();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPartPrices();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PartPrice.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "partpriceindex") {
					this.getPartPricesWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "part_price").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
